import { InjectableClass } from '@fino/lib-injection';
import _ from 'lodash';

export class FreshdeskFaqsService extends InjectableClass {
  constructor($q, $http, freshdeskApiConfig) {
    'ngInject';
    super({$q, $http, freshdeskApiConfig});

    const { apiKey } = this.freshdeskApiConfig;
    this.authorizationEncoded = btoa(`${apiKey}:X`);
  }

  getJson(url) {
    return this.$http.get(url, {
      headers: {
        Authorization: `Basic ${this.authorizationEncoded}`
      }
    });
  }

  getApiUrl(id, subject) {
    const { apiHost } = this.freshdeskApiConfig;

    switch(subject) {
      case 'folders':
        return `${apiHost}/solutions/categories/${id}/folders`;
      case 'articles' :
        return `${apiHost}/solutions/folders/${id}/articles`;
    }
    return '';
  }

  /*
    @param {array} parentSubject array with the parents id's.
    @param {string} subject the subject e.g. 'folders', 'articles'
  */
  getSubject(parentSubject, subject) {
    let requests = [];
    _.map(parentSubject, (childSubject) => {
      requests.push(this.getJson(this.getApiUrl(childSubject.id, subject)));
    });

    let deferred = this.$q.defer();
    let childSubjects = [];

    this.$q.all(requests).then(result => {
      _.map(result, (childSubject) => {
        childSubjects = _.union(childSubjects, childSubject.data);
      });
      deferred.resolve({subject: childSubjects});
    });

    return deferred.promise;
  }

  /*
    @param {array} categoriesID array the id's of the categories to be loaded
  */
  getFaqs(categoriesID = []) {
    let deferred = this.$q.defer();
    let categories = [];
    _.map(categoriesID, (categorie) => {
      categories.push({id: categorie});
    });
    let faqs = {categories: categories};
    this.getSubject(categories, 'folders').then((result) => {
      faqs.folders = result.subject;

      this.getSubject(result.subject, 'articles').then((result)=> {
        faqs.articles = result.subject;

        // Since folders have no category id, we have to get them from the corresponding article
        _.map(faqs.articles, (article) => {
          let folder = _.find(faqs.folders, {'id': article.folder_id});
          let categorie = _.find(faqs.categories, {'id': article.category_id});
          folder.category_id = categorie.id;
        });
        // Build up Tree Structure
        _.map(faqs.folders, (folder) => {
          let articles = _.filter(faqs.articles, {'folder_id': folder.id});
          folder.articles = articles;
        });
        _.map(faqs.categories, (categorie) => {
          let folders = _.filter(faqs.folders, {'category_id': categorie.id});
          categorie.folders = folders;
        });
        deferred.resolve({faqs: faqs});
      });
    });
    return deferred.promise;
  }

}



// WEBPACK FOOTER //
// ./node_modules/@fino/ng1-freshdesk-faqs/src/freshdesk-faqs.service.js